export default class BlockQuotes {
	static init() {

		let blocks = document.querySelectorAll('.block-quotes');

		blocks.forEach( (block) => {
			const swiper = block.querySelector('.swiper-quotes');
			const prev = block.querySelector(".swiper-quotes-button-prev");
			const next = block.querySelector(".swiper-quotes-button-next");
			new Swiper(swiper, {
				slidesPerView: "1",
				grabCursor: true,
				effect: 'fade',
				fadeEffect: {
					crossFade: true
				},
				navigation: {
					prevEl: prev,
					nextEl: next,
				}
			});
		});
	}
}
